import {
  MODELS_HELPER_TEXT,
  MODELS_PREFIX,
  openAiModelsFetch,
  withAllowedModelsHint,
} from "../models";
import { openaiUsage } from "../openai/usage";
import { OPENAI_COMPATIBLE_USAGE_HINT } from "../openai/usageHint";
import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const DEFAULT_FIREWORKS_BASE_URL =
  "https://api.fireworks.ai/inference/v1";

const MODELS_ENDPOINT = `${DEFAULT_FIREWORKS_BASE_URL}/models`;

const fireworksModelsFetch = openAiModelsFetch(
  "Fetch models from Fireworks AI",
  () => MODELS_ENDPOINT
);

export const fireworksAi = defineConnector({
  identifier: "fireworksAi",
  name: "Fireworks AI",
  tagLine: "Fast inference for open AI models",
  logo,
  protocol: "http",
  tags: ["ai", "engineering"],
  defaultUrlPattern: () => "https://api\\.fireworks\\.ai/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Create an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Go to [API keys](https://app.fireworks.ai/settings/users/api-keys) in your Fireworks AI account settings and create a new key.",
        },
      ],
    },
    {
      title: "Paste your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          placeholder: "fw_...",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
    {
      title: "Choose available models (optional)",
      items: [
        {
          kind: "list",
          label: "Available models",
          prefix: MODELS_PREFIX,
          columns: [
            {
              field: "name",
              placeholder: "accounts/fireworks/models/llama-v3p1-8b-instruct",
            },
          ],
          addLabel: "Add model",
          fetch: fireworksModelsFetch,
          helperText: MODELS_HELPER_TEXT,
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => MODELS_ENDPOINT,
  },
  usageHint: (configuration) =>
    withAllowedModelsHint(OPENAI_COMPATIBLE_USAGE_HINT, configuration),
  usage: openaiUsage(),
});
